import invariant from "invariant";
import { Link } from "react-router-dom";
import React from "react";

export const DocumentLink = ({ document, ...props }) => {
  const { Type, InvoiceID, CreditNoteID } = document;

  const link = {
    ACCREC: () => `/accounts_receivable/invoices/edit/${InvoiceID}`,
    ACCPAY: () => `/purchases/bills/edit/${InvoiceID}`,
    ACCRECCREDIT: () =>
      `/purchases/credit_notes/edit/${CreditNoteID}`,
    ACCPAYCREDIT: () => `/accounts_payable/credit_notes/edit/${CreditNoteID}`,
  }[Type]?.();

  invariant(Type, "Invalid Type");

  return <Link to={link} {...props} />;
};
